// @flow

import remote from './remote';

export function getUpcoming(query = {}) {
  return remote.get('rapidfire-challenges/upcoming', query);
}

export function getLive(query = {}) {
  return remote.get('rapidfire-challenges/live', query);
}

export function submitEntry(challengeId: string, data) {
  return remote.post(`challenges/${challengeId}/entries`, data);
}

export function updateEntry(entryId: string, data) {
  return remote.post(`entries/${entryId}`, data);
}
